import Accordion from "react-bootstrap/Accordion";
import Footer from "./small/Footer";
import { Icon } from "@iconify/react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { faker } from "@faker-js/faker";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { doc, setDoc, updateDoc } from "firebase/firestore";
import { firestoredb } from "./firebase";
import { async } from "@firebase/util";
import { collection, query, where, getDocs } from "firebase/firestore";
import { getParsedAccountByMint } from "@nfteyez/sol-rayz";
import { AnchorProvider, web3, setProvider } from "@project-serum/anchor";
import { clusterApiUrl } from "@solana/web3.js";
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "top",
    },
    title: {
      display: true,
      text: "Chart.js Line Chart",
    },
  },
};

const labels = ["January", "February", "March", "April", "May", "June", "July"];

export const data = {
  labels,
  datasets: [
    {
      label: "Dataset 1",
      data: labels.map(() => faker.datatype.number({ min: -1000, max: 1000 })),
      borderColor: "yellow",
      backgroundColor: "yellow",
    },
    {
      label: "Dataset 2",
      data: labels.map(() => faker.datatype.number({ min: -1000, max: 1000 })),
      borderColor: "white",
      backgroundColor: "white",
    },
  ],
};
const topRaffles = [
  {
    firstImg: "../../../assets/images/topraffle/img1.png",
    profImg: "../../../assets/images/topraffle/img2.png",
    title: "Cyber Girl Smoke ",
    inStock: "8",
    price: "145.55",
    userImg: "../../../assets/images/topraffle/img3.png",
    userName: "Nina Hazel",
  },
  {
    firstImg: "../../../assets/images/topraffle/main2.png",
    profImg: "../../../assets/images/topraffle/img2.png",
    title: "Cyber Girl Smoke ",
    inStock: "8",
    price: "145.55",
    userImg: "../../../assets/images/topraffle/img3.png",
    userName: "Nina Hazel",
  },
  {
    firstImg: "../../../assets/images/topraffle/main3.png",
    profImg: "../../../assets/images/topraffle/img2.png",
    title: "Cyber Girl Smoke ",
    inStock: "8",
    price: "145.55",
    userImg: "../../../assets/images/topraffle/img3.png",
    userName: "Nina Hazel",
  },
  {
    firstImg: "../../../assets/images/topraffle/main4.png",
    profImg: "../../../assets/images/topraffle/img2.png",
    title: "Cyber Girl Smoke ",
    inStock: "8",
    price: "145.55",
    userImg: "../../../assets/images/topraffle/img3.png",
    userName: "Nina Hazel",
  },
];

const NftDetails = () => {
  const [nftDetails, setDetails] = useState([]);
  const [LinkData, setLinkData] = useState("");
  const [NFTOwner, setOwner] = useState("");
  const [walletAddress, setWalletKey] = useState("");
  const [listStatus, setListStatus] = useState("");

  const location = useLocation();
  const opts = {
    preflightCommitment: "processed",
    confirmTransactionInitialTimeout: 90000,
  };
  const getProvider = () => {
    // const connection = new Connection(network, opts.preflightCommitment);
    var connection = new web3.Connection(clusterApiUrl("devnet"), {
      commitment: "confirmed",
      confirmTransactionInitialTimeout: 120000,
    });
    // console.log(connection);
    const provider = new AnchorProvider(
      connection,
      window.solana,
      opts.preflightCommitment
    );
    return provider;
  };

  const provider = getProvider();
  setProvider(provider);

  const getSingledata = () => {
    console.log(location);
    const result = location.pathname.split("/");
    console.log(result);
    var linkdata =
      "https://firebasestorage.googleapis.com/v0/b/metamuze-749cc.appspot.com/o/" +
      result[2] +
      location.search;

    setLinkData(linkdata);
    fetch(linkdata)
      .then((response) => response.json())
      .then((json) => {
        // console.log(json);
        var nftdetailsdata = {
          image: json.image,
          name: json.name,
          description: json.description,
          symbol: json.symbol,
          blockchain: json.blockchain,
        };

        setDetails(nftdetailsdata);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const listNFT = async (flag) => {
    const q = query(
      collection(firestoredb, "metamuze_CreateNFT"),
      where("jsonLink", "==", LinkData)
    );

    const querySnapshot = await getDocs(q);
    querySnapshot.forEach(async (doc1) => {
      await updateDoc(doc(firestoredb, "metamuze_CreateNFT", doc1.id), {
        listFlag: flag,
      }).then(() => {
        getListFlag();
      });
    });
  };
  const handleBuy = async () => {
    const parsedAccountByMint = await getParsedAccountByMint({
      mintAddress: "AM9vjvHPXGBvqBXJmzokbHdGeom3XSfxCoNKiCWF3hZk",
      connection: provider.connection,
    })
      .then((res) => {
        console.log(res);
        setOwner(res.account.data.parsed.info.owner);
        // console.log("Account by Mint");
        //sa
      })
      .catch((err) => {
        console.log("Error", err);
      });
    // console.log(parsedAccountByMint);
  };
  const getListFlag = async () => {
    console.log("dsadsa", LinkData);

    const q = query(
      collection(firestoredb, "metamuze_CreateNFT"),
      where("jsonLink", "==", LinkData)
    );

    const querySnapshot = await getDocs(q);
    querySnapshot.forEach(async (doc1) => {
      console.log(doc1.id);

      setListStatus(doc1.data().listFlag);
    });
    console.log("end");
  };
  useEffect(() => {
    getListFlag();
  }, [LinkData]);
  useEffect(() => {
    handleBuy();
  }, []);

  useEffect(() => {
    getSingledata();
    // console.log(result);
  }, []);

  const walletListner = async () => {
    const { solana } = window;

    if (solana) {
      try {
        const response = await solana.connect();
        // console.log("wallet account ", response.publicKey.toString());
        // console.log(response.publicKey.toString());

        setWalletKey(response.publicKey.toString());
      } catch (err) {
        // { code: 4001, message: 'User rejected the request.' }
      }
    }
  };

  useEffect(() => {
    walletListner();
  }, []);

  return (
    <>
      <main className="nft-detail-bg">
        <section>
          <div className="container">
            <div className="row">
              <div className="col-sm-5">
                <h3 id="nft-detail-title-mobile" className="nft-title">
                  {nftDetails.name}
                </h3>
                <img
                  className="nft-details-img"
                  src={nftDetails.image}
                  alt=""
                />

                <Accordion>
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <Icon className="ivon" icon="ph:chat-dots-fill" /> Detials
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="details-wrapper">
                        <div className="one-item-wrap">
                          <h3 className="detail-tit">Contact Address</h3>
                          <h3 className="details-answer">Tokenk... Q5DA</h3>
                        </div>

                        <div className="one-item-wrap">
                          <h3 className="detail-tit">Token ID</h3>
                          <h3 className="details-answer">khvueu354bkdfkb...</h3>
                        </div>

                        <div className="one-item-wrap">
                          <h3 className="detail-tit">Token Standard</h3>
                          <h3 className="details-answer answer-2">Metaplex</h3>
                        </div>

                        <div className="one-item-wrap">
                          <h3 className="detail-tit">Blockchain</h3>
                          <h3 className="details-answer answer-2">
                            <img
                              src="../../assets/images/icons/cryptocurrency_eth.png"
                              alt=""
                            />
                            {nftDetails.blockchain}
                          </h3>
                        </div>

                        <div className="one-item-wrap">
                          <h3 className="detail-tit">Metadata</h3>
                          <h3 className="details-answer answer-2">
                            Tokenk... Q5DA
                          </h3>
                        </div>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
              <div className="col-sm-7">
                <div className="detail-side">
                  <h3 id="nft-detail-title-desktop" className="nft-title">
                    {nftDetails.name}
                  </h3>
                  <div className="four-items">
                    <div className="owned-by-wrp">
                      <h3 className="ownedby">
                        Owned By: <span>Nina Hazel</span>
                      </h3>
                    </div>

                    <div className="views">
                      {/* <img src="../../public/assets/images/icons" alt="" /> */}
                      <Icon className="ivon" icon="carbon:view-filled" />
                      750 views
                    </div>

                    <div className="likes">
                      <Icon className="ivon" icon="bi:heart-fill" />
                      100 Favorites
                    </div>

                    <div className="more-options">
                      <Icon icon="ic:baseline-refresh" />
                      <Icon icon="akar-icons:link-out" />
                      <Icon icon="entypo:share" />
                      <Icon icon="bi:three-dots" />
                    </div>
                  </div>

                  <h3 className="currentprice">Current Price</h3>

                  <div className="priceandbuybtn">
                    <div className="price-wrapper">
                      <img
                        className="crypto-ico"
                        src="../../assets/images/icons/cryptocurrency_eth.png"
                        alt=""
                      />
                      15.60 <span>$450</span>
                    </div>

                    <div className="buy-makeoffer">
                      {listStatus == true ? (
                        <button
                          className="buybtn"
                          onClick={(e) => listNFT(false)}
                        >
                          Cancel{" "}
                        </button>
                      ) : (
                        <button
                          className="buybtn"
                          onClick={(e) => listNFT(true)}
                        >
                          List
                        </button>
                      )}
                      <button className="buybtn">Buy </button>

                      <button className="makeoffer">Make Offer </button>
                    </div>
                  </div>
                  <Accordion className="firs-acc">
                    <Accordion.Item eventKey="0">
                      <Accordion.Header>
                        <Icon className="ivon" icon="ph:chat-dots-fill" />
                        Attributes
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="attributes-wrap">
                          <div className="attributes-item-wrap">
                            <h4 className="titone">Background</h4>
                            <h4 className="tittwo">Mint</h4>
                            <h4 className="titthree">20% have this trait</h4>
                          </div>

                          <div className="attributes-item-wrap">
                            <h4 className="titone">Background</h4>
                            <h4 className="tittwo">Mint</h4>
                            <h4 className="titthree">20% have this trait</h4>
                          </div>

                          <div className="attributes-item-wrap">
                            <h4 className="titone">Background</h4>
                            <h4 className="tittwo">Mint</h4>
                            <h4 className="titthree">20% have this trait</h4>
                          </div>

                          <div className="attributes-item-wrap">
                            <h4 className="titone">Background</h4>
                            <h4 className="tittwo">Mint</h4>
                            <h4 className="titthree">20% have this trait</h4>
                          </div>

                          <div className="attributes-item-wrap">
                            <h4 className="titone">Background</h4>
                            <h4 className="tittwo">Mint</h4>
                            <h4 className="titthree">20% have this trait</h4>
                          </div>

                          <div className="attributes-item-wrap">
                            <h4 className="titone">Background</h4>
                            <h4 className="tittwo">Mint</h4>
                            <h4 className="titthree">20% have this trait</h4>
                          </div>

                          <div className="attributes-item-wrap">
                            <h4 className="titone">Background</h4>
                            <h4 className="tittwo">Mint</h4>
                            <h4 className="titthree">20% have this trait</h4>
                          </div>

                          <div className="attributes-item-wrap">
                            <h4 className="titone">Background</h4>
                            <h4 className="tittwo">Mint</h4>
                            <h4 className="titthree">20% have this trait</h4>
                          </div>

                          <div className="attributes-item-wrap">
                            <h4 className="titone">Background</h4>
                            <h4 className="tittwo">Mint</h4>
                            <h4 className="titthree">20% have this trait</h4>
                          </div>

                          <div className="attributes-item-wrap">
                            <h4 className="titone">Background</h4>
                            <h4 className="tittwo">Mint</h4>
                            <h4 className="titthree">20% have this trait</h4>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                      <Accordion.Header>
                        <Icon className="ivon" icon="ant-design:tag-filled" />
                        Price History
                      </Accordion.Header>
                      <Accordion.Body>
                        <Line options={options} data={data} />
                      </Accordion.Body>
                    </Accordion.Item>

                    <Accordion.Item eventKey="2">
                      <Accordion.Header>
                        <Icon className="ivon" icon="cil:hand-point-right" />
                        Offers
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="offer-wrap">
                          <div className="imageandtit">
                            <img
                              src="../../assets/images/icons/prof.png"
                              alt=""
                            />
                            <h3 className="prof-tit">Jay Williams</h3>
                          </div>

                          <h3 className="eth-tit"> Solona</h3>

                          <h3 className="bidplace">Bid Place</h3>
                          <div className="d-flex align-items-center balance-wrap">
                            <img
                              src="../../assets/images/topshops/icon-eth.png"
                              alt=""
                            />
                            <h6 class="eth-balance">213.21</h6>
                          </div>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                      <Accordion.Header>
                        <Icon
                          className="ivon"
                          icon="fluent:clipboard-bullet-list-rtl-20-filled"
                        />
                        Listing
                      </Accordion.Header>
                      <Accordion.Body>
                        <div className="text-center">
                          <img
                            src="../../assets/images/icons/healthicons_not-ok.png"
                            alt=""
                          />
                          <h3 className="listing-tit">Not Listed Yet !</h3>
                        </div>
                      </Accordion.Body>
                    </Accordion.Item>
                  </Accordion>
                </div>
              </div>

              <div className="col-12">
                <Accordion variant="dark">
                  <Accordion.Item eventKey="0">
                    <Accordion.Header>
                      <Icon
                        className="ivon"
                        icon="material-symbols:activity-zone"
                      />
                      Activity
                    </Accordion.Header>
                    <Accordion.Body>
                      <div className="activity-wrapper">
                        <table className="activity-tbl">
                          <tr>
                            <th>Item</th>
                            <th>NAME</th>
                            <th>TRANSACTION ID</th>
                            <th colSpan="2">TRANSACTION TYPE</th>
                            <th>TIME</th>

                            <th>TOTAL AMOUNT</th>
                            <th>BUYER</th>
                            <th>Seller</th>
                          </tr>

                          <tr>
                            <td>
                              <img
                                className="activity-prof-image"
                                src="../../assets/images/icons/activity.png"
                                alt=""
                              />
                            </td>

                            <td>Chines Tech Girl</td>
                            <td>7kjsdo........oieoweo5</td>
                            <td>
                              <span style={{ color: " #08FE5C" }}>Sale</span>
                            </td>
                            <td>
                              <span style={{ color: " #DFC500;" }}>ME v2</span>
                            </td>
                            <td>about 9 hours ago</td>
                            <td>
                              <img
                                className="crypto-ico"
                                src="../../assets/images/icons/cryptocurrency_eth.png"
                                alt=""
                              />
                              0.065 SOL
                            </td>

                            <td>Tjjhjh....Tikke</td>
                            <td>Ulldfoo...Yjhdf</td>
                          </tr>

                          <tr>
                            <td>
                              <img
                                className="activity-prof-image"
                                src="../../assets/images/icons/activity.png"
                                alt=""
                              />
                            </td>

                            <td>Chines Tech Girl</td>
                            <td>7kjsdo........oieoweo5</td>
                            <td>
                              <span style={{ color: " #08FE5C" }}>Sale</span>
                            </td>
                            <td>
                              <span style={{ color: " #DFC500;" }}>ME v2</span>
                            </td>
                            <td>about 9 hours ago</td>
                            <td>
                              <img
                                className="crypto-ico"
                                src="../../assets/images/icons/cryptocurrency_eth.png"
                                alt=""
                              />
                              0.065 SOL
                            </td>

                            <td>Tjjhjh....Tikke</td>
                            <td>Ulldfoo...Yjhdf</td>
                          </tr>
                        </table>
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                </Accordion>
              </div>
            </div>
          </div>
        </section>

        <section id="top-raffles">
          <div className="container">
            <div className="row">
              <div className="col-sm-12">
                <div className="title">
                  <h2 className="main-tite nft-details-more-collection">
                    <span> &#91;</span>More Collections <span> &#93;</span>
                  </h2>
                </div>
              </div>
            </div>
          </div>

          <div className="container">
            <div className="row">
              {topRaffles.map((item, index) => {
                return (
                  <div className="col-sm-6 col-lg-4 col-xl-4" key={index}>
                    <div className="top-raffle-single">
                      <div className="heart-love text-end">
                        <div className="icon-wrapping-hears">
                          <Icon
                            icon="ant-design:heart-filled"
                            className="heart-icon-single"
                          />
                          <span>1.2k</span>
                        </div>
                      </div>
                      <img
                        className="top-raffle-single-img"
                        src={item.firstImg}
                      />
                      <div className="d-flex align-items-center top-raffle-first">
                        <img
                          className="top-raffle-prof-imgp"
                          src={item.profImg}
                        />

                        <h3 className="raffle-it">{item.title}</h3>
                      </div>

                      <div className="d-flex align-items-center justify-content-between top-raffle-second">
                        <h3 className="instock">
                          in stock <span>{item.inStock}</span>
                        </h3>
                        <div className="d-flex align-items-center justify-content-between price">
                          <h3 className="price-tit">
                            price:
                            <img
                              className="etheriumico"
                              src="../../../assets/images/topraffle/img4.png"
                            />
                            <span>{item.price}</span>
                          </h3>
                        </div>
                      </div>
                      <div className="forborder-bott"></div>

                      <div className="d-flex align-items-center bottom-items justify-content-between top-raffle-third">
                        <div className="d-flex align-items-center">
                          <img
                            className="top-raffle-prof-imgp"
                            src={item.userImg}
                          />

                          <h3 className="seller-name">{item.userName}</h3>
                        </div>
                        <div>
                          <button className="place-bid">Place bid</button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
        </section>
        <Footer />
      </main>
    </>
  );
};
export default NftDetails;
